<template>
  <div class="container">
    <h1>Découvrez vos résultats</h1>
    <p class="text-center" id="arrow1">
      Pour le lancement de l’outil Naega DI, le service est <b>exceptionnellement offert</b> ; l’offre tarifaire, ainsi que vos <b>gains économiques</b> sont détaillés plus bas. Pour recevoir vos résultats complets, vous pouvez renseigner votre adresse email ci-dessous et ils vous seront envoyés d’ici quelques instants.
    </p>
    <p class="text-30 text-center"><em>{{ results.count }} nœuds</em> traités</p>
    <table id="arrow2">
      <thead>
        <tr>
          <th>Nom du noeud</th>
          <th>Débit</th>
          <th>Résultat</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="result in firstResults" :key="result.id">
          <td>{{ result.node }}</td>
          <td>{{ debit }}m&sup3;/h</td>
          <td>{{ (result.pression).toFixed(1) }} mCE</td>
        </tr>
      </tbody>
    </table>
    <button v-if="!showForm" class="btn btn-primary mt-4" @click="showForm=true">Recevoir mes résultats</button>
    <single-form :class="{fadeOut : fromFadeOut}" v-if="showForm && !formSent" @input-value="processInput" @form-submitted="showModal" :action=formBtnLabel errorMessage="Veuillez saiser une adresse mail valide" inputInformation="Vous ne recevrez aucune solicitation commerciale" inputType="text" inputLabel="Mon adresse mail" inputPlaceholder="example@mail.fr" :formIsValid=formIsValid class="mw-400"></single-form>
    <p v-if="formSent" id="tankYouMessage" class="text-30 text-primary text-center fw-medium mw-800 mt-3" :class="{ bounceIn : formSent }">Merci d’avoir utilisé notre service, vos résultats vous ont été envoyés par mail.</p>
    <div class="price-compare mt-5">
      <div class="row">
        <div class="col">
          <div class="card price-naega">
            <div class="card-body">
              <em>{{ Math.ceil(results.naegaCost) }}€</em>
              <span class="special-offer__label">Le tarif d'ici<br>quelques mois</span>
              <p class="fw-bold">Naega DI</p>
              <p>Résultat complet de votre modélisation reçu par email</p>
            </div>
            <hr>
            <div class="card-body">
              <ul>
                <li><b>Modélisation complète par mail</b></li>
                <li>Simulation de quelques secondes à 20 minutes</li>
                <li>Aucune inscription</li>
                <li>Outil en ligne</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col d-flex">
          <div class="card">
            <div class="card-body">
              <em>{{ Math.ceil(results.manualCost) }}€</em>
              <span class="special-offer__label">Ce que cela vous<br>aurait coûté</span>
              <p class="fw-bold">Contrôle manuel</p>
              <p>Moyenne effectué sur la base de 10% du nombre de noeud</p>
            </div>
            <hr>
            <div class="card-body" style="height: 100%;">
              <ul>
                <li>Contrôle de la pression manuel</li>
                <li>Durée moyenne du test de 4 jours</li>
                <li>Achat du logiciel</li>
                <li>Mise à jour du logiciel nécessaire</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="questionModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <svg width="68" height="68" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="34" cy="34" r="32.5" fill="#fff" stroke="#C5E5F5" stroke-width="3"/><path d="M18 30.059a16.059 16.059 0 0132.118 0 15.995 15.995 0 01-6.883 13.154L41.992 49.1a4.588 4.588 0 01-4.536 3.9h-6.795a4.588 4.588 0 01-4.535-3.9l-1.244-5.861A16.04 16.04 0 0118 30.059zM24.883 43.824h18.353" stroke="#3DA7DD" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M26.059 46.765l16-1.765v1.765l-16 2.117.615 2.118 15.385-2.118" stroke="#3DA7DD"/></svg>
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Créons ensemble vos services en ligne</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click=sendForm>
              <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.467 13.52a1.885 1.885 0 01-1.262.472c-.473 0-.927-.17-1.262-.473L7.001 9.447l-3.943 4.072a1.805 1.805 0 01-.579.355 1.95 1.95 0 01-1.372.005 1.808 1.808 0 01-.583-.35A1.613 1.613 0 01.136 13a1.48 1.48 0 01.006-1.24c.091-.197.225-.375.393-.524L4.636 7 .533 2.763A1.616 1.616 0 01.14 2.24 1.481 1.481 0 01.134.999C.224.802.356.623.523.473c.166-.151.364-.27.582-.351a1.95 1.95 0 011.373.005c.217.082.414.203.579.355L7 4.557 10.943.482c.165-.152.362-.273.58-.355a1.949 1.949 0 011.372-.005c.218.08.416.2.582.35.167.151.299.33.389.527a1.48 1.48 0 01-.006 1.24 1.617 1.617 0 01-.393.524L9.365 7.001l4.102 4.235c.166.15.297.328.387.524a1.479 1.479 0 010 1.236c-.09.196-.221.374-.387.524z" fill="#969696"/></svg>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <label class="form-label">Auriez-vous été prêt à payer pour ce service ?</label>
              <input type="radio" value="oui" name="myChoice" id="formChoiceYes" v-model="formData.choice">
              <label for="formChoiceYes" class="form-label">Oui</label>
              <input type="radio" value="non" name="myChoice" id="formChoiceNo" class="ms-5" v-model="formData.choice">
              <label for="formChoiceNo" class="form-label">Non</label>
              <label for="formMessage" class="form-label mt-2">Qu'aimeriez-vous rajouter ou modifier dans Naega-DI ?</label>
              <textarea class="form-control" id="formMessage" v-model="formData.message" rows="3"></textarea>
              <label for="formMessage2" class="form-label mt-2">Besoin d'autres services Naega en ligne liés à Epanet ? (ex : criticité...)</label>
              <textarea class="form-control" id="formMessage2" v-model="formData.message2" rows="3"></textarea>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click=sendForm>Envoyer ma réponse</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container-920 mt-70 d-flex flex-column align-items-center">
    <figure class="figure">
      <img src="../assets/naega_di_logo_ellipse.svg" class="figure-img img-fluid" alt="pompiers">
    </figure>
    <h2 class="text-center text-50 fw-bold mb-3" id="naega-univers">Naega DI, incorporé <br>au sein de l’univers Naega</h2>
    <p class="text-20 mt-5">Dans un contexte d’explosion des données et de complexification, où l’enjeu est d’exploiter au mieux le patrimoine et ses données, on constate un fort besoin pour vous, maître d’ouvrage, de : </p>
    <p class="visually-hidden">Suivre (observer), Analyser (synthétiser), Actualiser (simplifier), Arbitrer (décider), Partager (communiquer)</p>
    <figure class="figure mt-80">
      <img src="../assets/univers_naega.svg" class="figure-img img-fluid" alt="univers naega">
    </figure>
  </div>
  <page-footer/>
</template>

<script>
import SingleForm from '@/components/SingleForm.vue'
import PageFooter from '@/components/PageFooter.vue'
import { Modal } from 'bootstrap'

export default {
  name: 'Results',
  emits: ['send-email'],
  components: {
    SingleForm,
    PageFooter
  },
  props: {
    debit: Number,
    results: Object,
    formSent: Boolean
  },
  data () {
    return {
      showForm: false,
      questionModal: null,
      formData: {
        emailTo: null,
        message: null,
        message2: null,
        choice: null
      },
      fromFadeOut: false,
      formBtnLabel: 'Recevoir'
    }
  },
  mounted () {
    this.questionModal = new Modal(document.getElementById('questionModal'))
  },
  computed: {
    formIsValid () {
      return this.validateEmail(this.formData.emailTo)
    },
    firstResults () {
      return this.results.firstResults.slice(0, 3)
    }
  },
  methods: {
    processInput (email) {
      this.formData.emailTo = email
    },
    showModal () {
      this.questionModal.show()
    },
    sendForm () {
      this.$emit('send-email', this.formData)
      this.questionModal.hide()
      this.fromFadeOut = true
      this.formBtnLabel = 'Merci !'
    },
    validateEmail (email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    }
  }
}
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

h1 {
  margin-top: 5rem;
  margin-bottom: 2.5rem;
  font-size: 2.5rem;
}

#arrow1 {
  position: relative;
  font-size: 1.25rem;
  margin-bottom: 4rem;
}

#arrow1::after {
  content: '';
  background-image: url(data:image/svg+xml,%3Csvg%20width%3D%22172%22%20height%3D%22141%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M21.5%201c-19%2017-35.754%2057.41%200%2073.5C57.255%2090.59%2096.5%2078%2089%2059s-41-3-29.5%2031.5%2052.182%2052.011%20104.391%2046.076%22%20stroke%3D%22%23DD5128%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M164.024%20132.123l6.18%202.395a.5.5%200%2001.168.824l-4.745%204.628a.5.5%200%2001-.839-.258l-1.435-7.023a.5.5%200%2001.671-.566z%22%20fill%3D%22%23DD5128%22%2F%3E%3C%2Fsvg%3E);
  background-repeat: no-repeat;
  width: 172px;
  height: 141px;
  position: absolute;
  top: 7.75rem;
  left: 2rem;
}

#arrow2::after {
  content: '';
  background-image: url(data:image/svg+xml,%3Csvg%20width%3D%22265%22%20height%3D%22143%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M146.609%201c35.274%200%2079.583%207.23%2089.49%2024.762%2012.424%2021.985-52.35%2030.26-67.058%2048.424-19.316%2023.855-11.234%2056.589%2055.751%2056.589%2039.762%200%2058.501-23.469%2011.307-28.345-78.279-8.089-59.756%2029.864-184.837%2027.094C25.962%20128.964%206%20135%206%20135%22%20stroke%3D%22%23DD5128%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9.647%20138.75l-6.62-.316a.5.5%200%2001-.42-.728l3.036-5.892a.5.5%200%2001.877-.021l3.584%206.208a.5.5%200%2001-.457.749z%22%20fill%3D%22%23DD5128%22%2F%3E%3C%2Fsvg%3E);
  background-repeat: no-repeat;
  width: 265px;
  height: 143px;
  position: absolute;
  top: 24px;
  right: -60px;
}

em {
  font-style: normal;
  color: var(--naega-red);
  font-weight: 500;
}

table {
  margin-top: 1.5rem;
  margin-bottom: 3rem;
  position: relative;
}

thead th {
  text-align: center;
  padding: .5rem 5rem;
}

tbody td {
  text-align: center;
  font-size: .875rem;
}

tbody tr:nth-child(2) td {
  opacity: .6;
}

tbody tr:nth-child(3) td {
  opacity: .2;
}

.thank-you {
  padding: .5rem 3.75rem;
  font-weight: 700;
  color: var(--white);
  background-color: var(--naega-green);
  border-radius: .25rem;
}

.price-compare {
  width: 47.825rem;
  margin-bottom: 3.125rem;
}

.price-compare em {
  font-size: 2.75rem;
  font-weight: 700;
  color: var(--price-manual);
  margin-bottom: 1.5rem;
  display: inline-block;
}

.price-compare .price-naega em {
  color: var(--price-naega);
  position: relative;
}

.price-compare .price-naega em::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: var(--text-black);
  left: 0;
  top: 50%;
}

.special-offer__label {
  font-size: 1.875rem;
  float: right;
  color: var(--price-manual);
  -webkit-text-stroke: 1px;
}

.price-naega .special-offer__label {
  color: var(--naega-red);
}

.price-compare .card {
  border: 2px solid var(--price-manual);
}

.price-compare .card.price-naega {
  border-color: var(--price-naega);
}

.price-compare .card-body {
  padding: 3.125rem 1.875rem;
}

.price-compare ul {
  list-style-image: url(data:image/svg+xml,%3Csvg%20width%3D%2211%22%20height%3D%2211%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M10.582%2010.623c-.263.238-.62.371-.992.371s-.728-.133-.991-.371L5.5%207.422l-3.098%203.2c-.13.119-.284.214-.455.279a1.532%201.532%200%2001-1.079.004%201.423%201.423%200%2001-.457-.276%201.268%201.268%200%2001-.305-.414A1.162%201.162%200%2001.11%209.24%201.27%201.27%200%2001.42%208.83l3.223-3.328-3.224-3.33A1.27%201.27%200%2001.11%201.76%201.164%201.164%200%2001.106.785C.176.63.28.49.41.371A1.42%201.42%200%2001.868.096a1.533%201.533%200%20011.079.003c.17.065.325.16.455.28L5.5%203.58%208.599.379c.13-.12.284-.215.455-.28a1.531%201.531%200%20011.078-.003c.171.063.327.157.458.275.13.119.234.26.305.414a1.163%201.163%200%2001-.005.975%201.27%201.27%200%2001-.308.411l-3.223%203.33%203.223%203.328c.13.118.233.258.304.411a1.163%201.163%200%20010%20.971c-.07.154-.174.294-.304.412z%22%20fill%3D%22%23BD2B00%22%2F%3E%3C%2Fsvg%3E);
}

.price-compare .price-naega ul {
  list-style-image: url(data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M11.568.29c.51.442.578%201.23.154%201.76l-6%207.5c-.216.27-.53.433-.868.449a1.174%201.174%200%2001-.903-.365l-3.6-3.75a1.287%201.287%200%20010-1.768%201.166%201.166%200%20011.698%200l2.67%202.782L9.88.45a1.167%201.167%200%20011.69-.16z%22%20fill%3D%22%233DA7DD%22%2F%3E%3C%2Fsvg%3E);
}

.price-compare li {
  text-decoration: line-through;
  margin-bottom: 1rem;
}

.price-compare .price-naega li {
  text-decoration: none;
}

.modal-dialog {
  max-width: 23.75rem;
}

.modal-content {
  border: 3px solid var(--primary-light);
  border-radius: .625rem;
  padding: 3.375rem 2.125rem 1rem;
}

.modal-content > svg {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 0;
}

.modal-header {
  border-bottom: 0;
}

.modal-header .btn-close {
  position: absolute;
  right: 1rem;
  top: 1rem;
  background-image: none;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 700;
}

.modal-content label {
  font-size: .875rem;
}

textarea {
  resize: none;
  border: 1px solid var(--input-placeholder);
  border-radius: .3125rem;
  background-color: var(--input-textarea-bg);
  width: 100%;
  margin-bottom: .5rem;
}

input[type=radio] {
  margin-right: 1rem;
}

.modal-footer {
  border: 0;
  justify-content: center;
}

#tankYouMessage {
  opacity: 0;
  animation-duration: .5s;
  animation-fill-mode: forwards;
}
</style>
